/**
 * @ComponentFor CustomerServiceMainPage
 */
export default (): any => null;
